/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindViewsQueryResponse,
  FindViewsQueryParams,
} from "../types/FindViews.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findViewsQueryKey = (params: FindViewsQueryParams) =>
  [{ url: "/v1/view/find-views" }, ...(params ? [params] : [])] as const

export type FindViewsQueryKey = ReturnType<typeof findViewsQueryKey>

/**
 * @summary Find views
 * {@link /v1/view/find-views}
 */
export async function findViews(
  params: FindViewsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindViewsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/view/find-views`, params, ...requestConfig })
  return res
}

export function findViewsQueryOptions(
  params: FindViewsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findViewsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindViewsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindViewsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findViews(params, { ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @summary Find views
 * {@link /v1/view/find-views}
 */
export function useFindViews<
  TData = ResponseConfig<FindViewsQueryResponse>,
  TQueryData = ResponseConfig<FindViewsQueryResponse>,
  TQueryKey extends QueryKey = FindViewsQueryKey,
>(
  params: FindViewsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindViewsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findViewsQueryKey(params)

  const query = useQuery(
    {
      ...findViewsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
